/*
Theme JS
Version: v1.2
Date: 2026-01-06

CHANGELOG
v1.2
- Fix: Add missing static PARTNER_PARAM_KEY property to PartnerSelect, and update all references to use it.

v1.1
- Fix: Guard AOS.refresh() in updatePartnerElems() to prevent ReferenceError when AOS is not loaded.

v1.0
- Fix: Prevent CustomerDashboard and related modules from initializing on non-account pages.
- Fix: Add null guards for DashboardProfileName inputs to avoid "null.value" crashes.
- Fix: Gate DashboardPersonalize and preferences module to avoid crashes when dashboard modals are absent.
*/
//
class PartnerSelect {
  static selectors = {
    partner_name: "[data-partner-name]",
    hidden_when_has_partner: "[data-hideon-partner]",
    show_when_has_partner: "[data-showon-partner]",
    show_when_no_partner: "[data-showon-no-partner]",
  };

  static PARTNER_PARAM_KEY = "pws";

  constructor(container) {
    this.wrapper = container;
    this.partner_names = document.querySelectorAll(
      PartnerSelect.selectors.partner_name
    );

    this.init();
  }

  async init() {
    if (window.partner) this.setPrefPartner(partner);
    document.addEventListener("theme:partner:update", (event) => {
      console.log("theme:partner:update", event);
      const partner = event.detail.partner;
      console.log("theme:partner:update", partner);
      this.setPrefPartner(partner);
    });

    this.loadUrlAction();
  }

  async setPrefPartner(partner) {
    this.current_partner = partner;
    this.updateHeader(partner.displayName);
    this.updatePartnerElems();

    const currentURL = new URL(window.location);
    currentURL.searchParams.set(PartnerSelect.PARTNER_PARAM_KEY, partner.siteName);
    window.history.replaceState(null, "partnerfound", currentURL);
    // this.updateHomePage(partner.siteName);
  }

  async loadUrlAction() {
    const urlSearchParam = new URLSearchParams(window.location.search);
    const action = urlSearchParam.get("action");

    if (!action) return;

    if (action === "checkout_change_insider") {
      // MicroModal.close("info-partner");
      await new Promise((r) => setTimeout(r, 1000));
      MicroModal.show("find-your-consultant", {
        disableScroll: true,
        disableFocus: true,
      });

      console.log("checkout_change_insider", $("#fyc-modal-overlay"));
      $("#fyc-modal-overlay").on("click", () => {
        window.customCheckout();
      });
    }
  }

  setNoPartner() {
    this.show_when_no_partner = document.querySelectorAll(
      PartnerSelect.selectors.show_when_no_partner
    );
    this.show_when_no_partner.forEach((elem) =>
      elem.classList.remove("d-none")
    );

    const currentURL = new URL(window.location);
    currentURL.searchParams.delete(PartnerSelect.PARTNER_PARAM_KEY);
    sessionStorage.removeItem(OVERRIDE_PARTNER_STORAGE_KEY);
    window.history.replaceState(null, "nopartnerfound", currentURL);
  }

  updateHeader(displayName) {
    this.partner_names.forEach((elem) => (elem.innerHTML = displayName));
  }

  updatePartnerElems() {
    console.log("updatePartnerElems");
    this.elems_to_hide = document.querySelectorAll(
      PartnerSelect.selectors.hidden_when_has_partner
    );
    this.elems_to_show = document.querySelectorAll(
      PartnerSelect.selectors.show_when_has_partner
    );
    this.elems_to_hide.forEach((elem) => elem.classList.add("d-none"));
    this.elems_to_show.forEach((elem) => elem.classList.remove("d-none"));

    if (typeof AOS !== 'undefined') AOS.refresh();
  }

  async updateHomePage(siteName) {
    //   if (theme.is_homepage) {
    //     const partner = await this.repository.searchPartner({
    //       site: siteName,
    //     });
    //     if (partner !== undefined && partner !== null) {
    //       document.dispatchEvent(
    //         new CustomEvent("theme:partner:homepage", {
    //           detail: partner,
    //         })
    //       );
    //     }
    //   }
  }
}

class PartnerInfoModal {
  static selectors = {
    partner_name: "[data-partner-name]",
    partner_image: "[data-partner-image]",
    partner_phone: "[data-partner-phone]",
    partner_email: "[data-partner-email]",
    partner_facebook: "[data-partner-facebook]",
    partner_instagram: "[data-partner-instagram]",
    partner_tiktok: "[data-partner-tiktok]",
    partner_about_you: "[data-partner-about-you]",
    remove_consultant: "[data-remove-consultant]",
  };

  constructor() {
    this.wrapper = document.querySelector(".partner-modal");
    this.init();
  }

  init() {
    modal("partner-info");
    document.addEventListener("theme:partner:update", (event) => {
      const partner = event.detail.partner;
      this.renderPartnerModal(partner);
    });

    this.wrapper
      .querySelector(PartnerInfoModal.selectors.remove_consultant)
      .addEventListener("click", () => {
        const currentURL = new URL(window.location);
        currentURL.searchParams.delete(PartnerSelect.PARTNER_PARAM_KEY);
        localStorage.removeItem("CURRENT_SITE");
        sessionStorage.setItem("PREFERRED_SITE", null);
        location.replace(currentURL);
      });
  }

  renderPartnerModal(partner) {
    if (partner.profileImage)
      this.wrapper.querySelector(PartnerInfoModal.selectors.partner_image).src =
        partner.profileImage;

    this.wrapper.querySelector(
      PartnerInfoModal.selectors.partner_phone
    ).innerHTML = "+1 3429339000";

    if (partner.email)
      this.wrapper.querySelector(
        PartnerInfoModal.selectors.partner_email
      ).innerHTML = partner.email;

    if (partner.aboutYou)
      this.wrapper.querySelector(
        PartnerInfoModal.selectors.partner_about_you
      ).innerHTML = partner.aboutYou;
  }
}

class CustomerDashboard {
  static selectors = {
    navigations: "[data-dashboard-nav]",
    sections: "[data-dashboard-section]",
    sectionsWrap: "[data-dashboard-sections-wrap]",
  };

  constructor() {
    this.sectionsWrap = document.querySelector(
      CustomerDashboard.selectors.sectionsWrap
    );

    // Bail if we are not on a customer dashboard page
    if (!this.sectionsWrap) return;

    this.navigations = document.querySelectorAll(
      CustomerDashboard.selectors.navigations
    );
    this.sections = document.querySelectorAll(CustomerDashboard.selectors.sections);

    this.init();
  }

  init() {
    modal("dashboard-error");
    this.initializeEvents();
    new DashboardProfile();
  }

  initializeEvents() {
    this.navigations.forEach((navigation) => {
      navigation.addEventListener("click", this.onNavItemClick.bind(this));
    });

    this.renderDefaultNavItem();
  }

  renderDefaultNavItem() {
    // Get hash value from URL, removing the '#' if present
    const urlSection = window.location.hash.substring(1);
    const defaultSection = "profile";
    if (urlSection && urlSection != "") this.showSection(urlSection);
    else this.showSection(defaultSection);
  }

  onNavItemClick(event) {
    const targetSectionKey = event.currentTarget.dataset.dashboardNav;

    // Scroll to the section on mobile screens
    if (window.innerWidth < 768) {
      const targetElement = document.querySelector(
        `.dashboard-${targetSectionKey}`
      );
      if (targetElement) {
        setTimeout(() => {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }

    // Reload any iframes in the target section
    const targetSection = document.querySelector(
      `[data-dashboard-section="${targetSectionKey}"]`
    );
    if (targetSection) {
      const iframes = targetSection.querySelectorAll("iframe");
      if (iframes.length > 0) {
        iframes.forEach((iframe) => {
          if (iframe.src) {
            iframe.src = iframe.src;
            iframe.onload = () => {
              this.showSection(targetSectionKey);
            };
          }
        });
      } else {
        this.showSection(targetSectionKey);
      }
    }
  }

  showSection(key) {
    const targetSection = Array.from(this.sections).find(
      (section) => section.dataset.dashboardSection === key
    );
    const targetNavItem = Array.from(this.navigations).find(
      (navItem) => navItem.dataset.dashboardNav === key
    );
    if (!targetSection || !targetNavItem) return;

    // Show section
    this.sections.forEach((section) => section.classList.add("hidden"));
    targetSection.classList.remove("hidden");
    this.sectionsWrap.classList.add("visible");

    // Highlight nav
    this.navigations.forEach((nav) => nav.classList.remove("is-active"));
    targetNavItem.classList.add("is-active");

    // Set hash
    window.location.hash = key;
  }
}

class DashboardProfile {
  static selectors = {};

  constructor() {
    this.init();
  }

  init() {
    modal("profile");
    new DashboardProfileName();
    new DashboardProfileEmail();
    new DashboardProfilePhone();
    new DashboardProfilePassword();
    new DashboardProfileImage();
    new DashboardProfileAddresses();
  }
}

class DashboardProfileAddresses {
  static selectors = {
    templateAddresses: "[data-address-wrapper]",
    addressNewForm: "[data-new-address-form]",
    addressNewFormInner: "[new-address-form-inner]",
    btnNew: ".address-new-toggle",
    btnEdit: ".address-edit-toggle",
    btnDelete: ".address-delete",
    classHide: "hide",
    dataFormId: "data-form-id",
    dataConfirmMessage: "data-confirm-message",
    defaultConfirmMessage: "Are you sure you wish to delete this address?",
    editAddress: "#EditAddress",
    addressCountryNew: "AddressCountryNew",
    addressProvinceNew: "AddressProvinceNew",
    addressProvinceContainerNew: "AddressProvinceContainerNew",
    addressCountryOption: ".address-country-option",
    addressCountry: "AddressCountry",
    addressProvince: "AddressProvince",
    addressProvinceContainer: "AddressProvinceContainer",
  };

  constructor() {
    this.init();
  }

  init() {
    if (Shopify.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector(
        DashboardProfileAddresses.selectors.addressCountryNew,
        DashboardProfileAddresses.selectors.addressProvinceNew,
        {
          hideElement:
            DashboardProfileAddresses.selectors.addressProvinceContainerNew,
        }
      );
    }

    const countryOptions = document.querySelectorAll(
      DashboardProfileAddresses.selectors.addressCountryOption
    );

    countryOptions.forEach((option) => {
      const formId = option.getAttribute(
        DashboardProfileAddresses.selectors.dataFormId
      );
      const countrySelector = `${DashboardProfileAddresses.selectors.addressCountry}_${formId}`;
      const provinceSelector = `${DashboardProfileAddresses.selectors.addressProvince}_${formId}`;
      const containerSelector = `${DashboardProfileAddresses.selectors.addressProvinceContainer}_${formId}`;
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector,
      });
    });

    const deleteButtons = document.querySelectorAll(
      DashboardProfileAddresses.selectors.btnDelete
    );
    if (deleteButtons.length) {
      deleteButtons.forEach((element) => {
        element.addEventListener("click", function () {
          const formId = this.getAttribute(
            DashboardProfileAddresses.selectors.dataFormId
          );
          const confirmMessage = this.getAttribute(
            DashboardProfileAddresses.selectors.dataConfirmMessage
          );
          if (
            confirm(
              confirmMessage ||
                DashboardProfileAddresses.selectors.defaultConfirmMessage
            )
          ) {
            Shopify.postLink("/account/addresses/" + formId, {
              parameters: {
                _method: "delete",
              },
            });
          }
        });
      });
    }
  }
}

class DashboardFormHelper {
  static updateDOM({ data, elem, attr = "innerHTML" }) {
    if (!elem) return;
    elem[attr] = data;
  }

  static preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  static debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  constructor({ btnElem, inputElems = null, modalName = null }) {
    this.btnElem = btnElem;
    this.inputElems = inputElems;
    this.modalName = modalName;
  }

  setLoading() {
    if (!this.btnElem) return;
    this.btnElem.innerHTML = "Saving changes..";
    this.btnElem.setAttribute("disabled", "disabled");

    if (!this.inputElems) return;
    this.inputElems.forEach((elem) =>
      elem.setAttribute("disabled", "disabled")
    );
  }

  setCompleted(transitionDelay = BUTTON_TRANSITION_DURATION) {
    if (!this.btnElem) return;
    this.btnElem.innerHTML = "Changes Saved";
    this.btnElem.classList.add("has-success");

    setTimeout(() => {
      this.btnElem.classList.remove("has-success");
      const $modal = document.querySelector(
        `.dashboard-modal#${this.modalName}`
      );
      this.btnElem.innerHTML = "Save Changes";
      const $overlay = $modal.querySelector(".modal__overlay");
      $overlay.click();
    }, transitionDelay);

    if (!this.inputElems) return;
    this.inputElems.forEach((elem) => elem.removeAttribute("disabled"));
    this.btnElem.removeAttribute("disabled", "disabled");
  }

  setReady() {
    if (!this.btnElem) return;
    this.btnElem.innerHTML = "Save Changes";
    this.btnElem.classList.remove("has-success");
    this.btnElem.removeAttribute("disabled", "disabled");

    if (!this.inputElems) return;
    this.inputElems.forEach((elem) => elem.removeAttribute("disabled"));
  }

  toggleButton(isValid) {
    if (!this.btnElem) return;

    if (!isValid) this.btnElem.setAttribute("disabled", "disabled");
    else this.btnElem.removeAttribute("disabled");
  }
}

const BUTTON_TRANSITION_DURATION = 2000;
class DashboardErrorModal {
  static selectors = {
    modal: "#dashboard-error",
    title: "[data-error-modal-title]",
    subtitle: "[data-error-modal-subtitle]",
  };

  static message_map = {
    "Enter a valid phone number to use this delivery method":
      "Enter a valid phone number",
    "Phone has already been taken":
      "Your phone number is already in our system. <br><br>Please enter a different phone number",
  };

  constructor(customMessage) {
    this.modal = document.querySelector(DashboardErrorModal.selectors.modal);
    this.modal_title = this.modal.querySelector(
      DashboardErrorModal.selectors.title
    );
    this.modal_subtitle = this.modal.querySelector(
      DashboardErrorModal.selectors.subtitle
    );
    this.error_message = customMessage;
  }

  showError(error) {
    let data = null;
    try {
      data = JSON.parse(error.message);
    } catch {}

    let errorMessage = "";
    if (data && data.error) {
      if (typeof data.error == "string" || data.error instanceof String)
        errorMessage = data.error;
      else if (data.error.length > 0) errorMessage = data.error[0].message;
    }

    if (DashboardErrorModal.message_map[errorMessage])
      errorMessage = DashboardErrorModal.message_map[errorMessage];

    window.MicroModal.show("dashboard-error", {
      disableScroll: true,
      disableFocus: true,
    });
    if (errorMessage)
      this.modal_subtitle.innerHTML = this.error_message || errorMessage;
  }
}

class DashboardProfileName {
  static selectors = {
    first_name: "#profile-first-name-input",
    last_name: "#profile-last-name-input",
    name_submit: "[data-name-submit]",
    profile_name: "[data-dashboard-profile-name]",
    aside_profile_name: "[data-dashboard-aside-name]",
  };

  constructor() {
    this.wrapper = document;
    this.first_name_input = this.wrapper.querySelector(
      DashboardProfileName.selectors.first_name
    );
    this.last_name_input = this.wrapper.querySelector(
      DashboardProfileName.selectors.last_name
    );
    this.name_submit = this.wrapper.querySelector(
      DashboardProfileName.selectors.name_submit
    );

    // Bail if required elements are missing (prevents crashes on non-dashboard pages)
    if (!this.first_name_input || !this.last_name_input || !this.name_submit) return;

    this.profile_name = this.wrapper.querySelector(
      DashboardProfileName.selectors.profile_name
    );
    this.aside_profile_name = document.querySelector(
      DashboardProfileName.selectors.aside_profile_name
    );

    this.initialFirstName = this.first_name_input.value;
    this.initialLastName = this.last_name_input.value;
    this.firstName = this.initialFirstName;
    this.lastName = this.initialLastName;

    this.name_submit.addEventListener("click", this.onNameSubmit.bind(this));
    this.first_name_input.addEventListener(
      "keyup",
      this.onFirstNameUpdate.bind(this)
    );
    this.last_name_input.addEventListener(
      "keyup",
      this.onLastNameUpdate.bind(this)
    );
  }

  init() {
    this.first_name_input.addEventListener(
      "input",
      this.onNameChange.bind(this)
    );
    this.last_name_input.addEventListener(
      "input",
      this.onNameChange.bind(this)
    );
    this.name_submit.addEventListener("click", this.onNameSubmit.bind(this));
  }

  onNameChange() {
    // Update name
    this.firstName = this.first_name_input.value;
    this.lastName = this.last_name_input.value;
    // Disable if name is empty
    const isValid =
      this.first_name_input.checkValidity() &&
      this.last_name_input.checkValidity() &&
      validateTextInput(this.firstName) &&
      validateTextInput(this.lastName);
    this.form_helper.toggleButton(isValid);
  }

  async onNameSubmit() {
    try {
      this.form_helper.setLoading();
      //   // Update name
      const data = await this.apiService.setName(this.firstName, this.lastName);

      //   // Update name in UI
      const name = data.message;
      DashboardFormHelper.updateDOM({ data: name, elem: this.profile_name });
      DashboardFormHelper.updateDOM({
        data: name,
        elem: this.aside_profile_name,
      });

      //   // Update button state
      this.form_helper.setCompleted();
    } catch (e) {
      console.log("ERROR", e);
      this.form_helper.setReady();
      this.error_modal.showError(e);
    }
  }
}

class DashboardProfilePhone {
  static selectors = {
    phone: "#profile-phone-input",
    phone_submit: "[data-phone-submit]",
    profile_phone: "[data-profile-phone]",
  };

  constructor() {
    this.wrapper = document;
    this.phone_input = this.wrapper.querySelector(
      DashboardProfilePhone.selectors.phone
    );
    this.phone_submit = this.wrapper.querySelector(
      DashboardProfilePhone.selectors.phone_submit
    );
    this.profile_phone = this.wrapper.querySelector(
      DashboardProfilePhone.selectors.profile_phone
    );
    this.initialPhone = this.phone_input.value;
    this.phone = this.initialPhone;
    this.form_helper = new DashboardFormHelper({
      btnElem: this.phone_submit,
      inputElems: [this.phone_input],
      modalName: "profile-phone",
    });
    this.error_modal = new DashboardErrorModal();
    this.apiService = new ApiService();
    this.init();
  }

  init() {
    this.phone_input.addEventListener("input", this.onPhoneChange.bind(this));
    this.phone_submit.addEventListener("click", this.onPhoneSubmit.bind(this));
  }

  onPhoneChange() {
    this.phone = this.phone_input.value;
    const isValid = this.phone_input.checkValidity();
    this.form_helper.toggleButton(isValid);
  }

  async onPhoneSubmit() {
    try {
      this.form_helper.setLoading();

      const data = await this.apiService.setPhone(this.phone);
      DashboardFormHelper.updateDOM({
        data: data.message,
        elem: this.profile_phone,
      });
      this.form_helper.setCompleted();
    } catch (e) {
      this.form_helper.setReady();
      this.error_modal.showError(e);
    }
  }
}

class DashboardProfilePassword {
  static selectors = {
    password: "#profile-password-input",
    confirm_password: "#profile-confirm-password-input",
    password_submit: "[data-password-submit]",
    password_requirements: ".password-requirements li",
  };

  constructor() {
    this.wrapper = document;

    // Edit password form elems
    this.password_input = this.wrapper.querySelector(
      DashboardProfilePassword.selectors.password
    );
    this.confirm_password_input = this.wrapper.querySelector(
      DashboardProfilePassword.selectors.confirm_password
    );
    this.password_submit = this.wrapper.querySelector(
      DashboardProfilePassword.selectors.password_submit
    );
    this.password_requirements = this.wrapper.querySelectorAll(
      DashboardProfilePassword.selectors.password_requirements
    );

    // Edit password states
    this.password = "";
    this.confirm_password = "";
    this.apiService = new ApiService();

    this.form_helper = new DashboardFormHelper({
      btnElem: this.password_submit,
      inputElems: [this.password_input, this.confirm_password_input],
    });
    this.error_modal = new DashboardErrorModal();
    this.init();
  }

  init() {
    // Attach event listeners to edit password form
    this.password_input.addEventListener(
      "input",
      this.onPasswordChange.bind(this)
    );
    this.confirm_password_input.addEventListener(
      "input",
      this.onPasswordChange.bind(this)
    );
    this.password_submit.addEventListener(
      "click",
      this.onPasswordSubmit.bind(this)
    );
  }

  updateRequirementStatus(isMet, requirementElement) {
    if (isMet) {
      requirementElement.classList.add("met");
    } else {
      requirementElement.classList.remove("met");
    }
  }

  validatePassword() {
    const password = this.password_input.value;
    const lengthRequirement = password.length >= 8 && password.length <= 20;
    const uppercaseRequirement = /[A-Z]/.test(password);
    const lowercaseRequirement = /[a-z]/.test(password);
    const numberRequirement = /\d/.test(password);
    const specialCharRequirement = /[!@#$%^&*]/.test(password);

    const requirementsMet =
      lengthRequirement &&
      uppercaseRequirement &&
      lowercaseRequirement &&
      numberRequirement &&
      specialCharRequirement;

    this.updateRequirementStatus(
      lengthRequirement,
      this.password_requirements[0]
    );
    this.updateRequirementStatus(
      uppercaseRequirement,
      this.password_requirements[1]
    );
    this.updateRequirementStatus(
      lowercaseRequirement,
      this.password_requirements[2]
    );
    this.updateRequirementStatus(
      numberRequirement,
      this.password_requirements[3]
    );
    this.updateRequirementStatus(
      specialCharRequirement,
      this.password_requirements[4]
    );

    return requirementsMet;
  }

  onPasswordChange() {
    // Update password
    this.password = this.password_input.value;
    this.confirm_password = this.confirm_password_input.value;
    const requirementPassed = this.validatePassword();
    if (this.password !== this.confirm_password)
      this.confirm_password_input.setCustomValidity("Password does not match");
    else this.confirm_password_input.setCustomValidity("");

    const isPasswordValid =
      this.password_input.checkValidity() &&
      this.confirm_password_input.checkValidity() &&
      requirementPassed;
    this.form_helper.toggleButton(isPasswordValid);
  }

  async onPasswordSubmit() {
    try {
      this.form_helper.setLoading();
      await this.apiService.setPassword(this.password, this.confirm_password);
      this.form_helper.setCompleted(5000);
      location.reload();
    } catch (e) {
      this.form_helper.setReady();
      this.error_modal.showError(e);
    }
  }
}

class DashboardProfileEmail {
  static selectors = {
    email: "#profile-email-input",
    email_submit: "[data-email-submit]",
    profile_email: "[data-profile-email]",
  };

  constructor() {
    this.wrapper = document;
    // Edit email form elems
    this.email_input = this.wrapper.querySelector(
      DashboardProfileEmail.selectors.email
    );
    this.email_submit = this.wrapper.querySelector(
      DashboardProfileEmail.selectors.email_submit
    );

    // Edit email data elems
    this.profile_email = this.wrapper.querySelector(
      DashboardProfileEmail.selectors.profile_email
    );
    this.initialEmail = this.email_input.value;
    this.email = this.initialEmail;

    this.form_helper = new DashboardFormHelper({
      btnElem: this.email_submit,
      inputElems: [this.email_input],
      modalName: "profile-email",
    });
    this.error_modal = new DashboardErrorModal();
    this.apiService = new ApiService();
    this.init();
  }

  init() {
    this.email_input.addEventListener("input", this.onEmailChange.bind(this));
    this.email_submit.addEventListener("click", this.onEmailSubmit.bind(this));
  }

  onEmailChange() {
    this.email = this.email_input.value;
    const isValid =
      this.email_input.checkValidity() &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
    this.form_helper.toggleButton(isValid);
  }

  async onEmailSubmit() {
    try {
      this.form_helper.setLoading();
      const data = await this.apiService.setEmail(this.email);
      DashboardFormHelper.updateDOM({
        data: data.message,
        elem: this.profile_email,
      });
      this.form_helper.setCompleted();
    } catch (e) {
      this.form_helper.setReady();
      this.error_modal.showError(e);
    }
  }
}

class DashboardProfileImage {
  static selectors = {
    image_upload: "#profile-upload",
    image_submit: "[data-image-submit]",
    image_remove: "[data-image-remove]",
    image_drop: "[data-profile-drop]",
    image_preview: "[data-profile-preview]",
    inputgroup: ".inputgroup",
    profile_image: "[data-profile-image]",
  };

  static MAX_IMAGE_SIZE = 5242880;

  constructor(wrapper) {
    this.wrapper = document;
    this.image_input = this.wrapper.querySelector(
      DashboardProfileImage.selectors.image_upload
    );
    this.image_submit = this.wrapper.querySelector(
      DashboardProfileImage.selectors.image_submit
    );
    this.image_remove = this.wrapper.querySelector(
      DashboardProfileImage.selectors.image_remove
    );
    this.image_drop = this.wrapper.querySelector(
      DashboardProfileImage.selectors.image_drop
    );
    this.image_preview = this.wrapper.querySelector(
      DashboardProfileImage.selectors.image_preview
    );
    this.inputgroup = this.wrapper.querySelector(
      DashboardProfileImage.selectors.inputgroup
    );
    this.profile_images = document.querySelectorAll(
      DashboardProfileImage.selectors.profile_image
    );

    // Image upload states
    this.profile_image = null;

    this.apiService = new ApiService();
    this.form_helper = new DashboardFormHelper({
      btnElem: this.image_submit,
      inputElems: [this.image_input],
      modalName: "profile-image",
    });
    this.error_modal = new DashboardErrorModal();
    this.reader = new FileReader();
    this.init();
  }

  init() {
    this.image_input.addEventListener("change", this.onImageChange.bind(this));
    this.image_submit.addEventListener("click", this.onImageSubmit.bind(this));
    this.image_remove.addEventListener("click", this.onImageRemove.bind(this));
    ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
      this.image_drop.addEventListener(
        eventName,
        DashboardFormHelper.preventDefaults,
        false
      );
    });
    ["dragenter", "dragover"].forEach((eventName) =>
      this.image_drop.addEventListener(
        eventName,
        () => this.image_drop.classList.add("highlight"),
        false
      )
    );
    ["dragleave", "drop"].forEach((eventName) =>
      this.image_drop.addEventListener(
        eventName,
        () => this.image_drop.classList.remove("highlight"),
        false
      )
    );
    this.image_drop.addEventListener(
      "drop",
      this.onImageDrop.bind(this),
      false
    );
  }

  /**
   * On image change
   */
  onImageChange(event) {
    const files = event.target.files;
    const file = files[0];
    this.profile_image = file;
    this.update();
  }

  /**
   * On image mouse drop
   * @param {Event} event
   */
  onImageDrop(event) {
    const dt = event.dataTransfer;
    const file = dt && dt.files && dt.files[0];
    this.profile_image = file;

    this.update();
  }

  /**
   * On image remove click
   */
  onImageRemove() {
    this.profile_image = null;
    this.update();
  }

  /**
   * Update UI on image change
   */
  update() {
    const isNotImage =
      this.profile_image && !this.profile_image.type.includes("image");
    if (isNotImage) {
      this.profile_image = null;
      this.error_modal.showError({
        message: JSON.stringify({
          error: [{ message: "You can only upload an image file" }],
        }),
      });
    }

    const isSizeExceed =
      this.profile_image &&
      this.profile_image.size > DashboardProfileImage.MAX_IMAGE_SIZE;
    this.profile_image &&
      new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          const mp = (img.width * img.height) / 1000000;
          resolve(mp);
        };
        img.src = URL.createObjectURL(this.profile_image);
      }).then((mp) => {
        if (mp > 25) {
          this.profile_image = null;
          this.error_modal.showError({
            message: JSON.stringify({
              error: [
                {
                  message:
                    "Image resolution too high. Maximum 25 megapixels allowed.",
                },
              ],
            }),
          });
          this.updatePreview();
        }
      });
    if (isSizeExceed) {
      this.profile_image = null;
      this.error_modal.showError({
        message: JSON.stringify({
          error: [{ message: "You can only upload up to 5MB" }],
        }),
      });
    }

    this.form_helper.toggleButton(!!this.profile_image);
    this.updatePreview();
  }

  /**
   * Update preview image
   */
  updatePreview() {
    if (this.profile_image) {
      this.reader.readAsDataURL(this.profile_image);
      this.reader.onloadend = () => {
        DashboardFormHelper.updateDOM({
          data: this.reader.result,
          elem: this.image_preview,
          attr: "src",
        });
        this.image_preview.classList.remove("d-none");
        this.image_remove.classList.remove("d-none");
        this.inputgroup.classList.add("d-none");
      };
    } else {
      DashboardFormHelper.updateDOM({
        data: "",
        elem: this.image_preview,
        attr: "src",
      });
      this.image_preview.classList.add("d-none");
      this.image_remove.classList.add("d-none");
      this.inputgroup.classList.remove("d-none");
    }
  }

  async onImageSubmit() {
    try {
      this.form_helper.setLoading();
      // Update image
      await this.setImageAsProfile(this.profile_image);
      this.reader.readAsDataURL(this.profile_image);
      this.reader.onloadend = () => {
        this.profile_images.forEach((elem) =>
          DashboardFormHelper.updateDOM({
            data: this.reader.result,
            elem,
            attr: "src",
          })
        );
      };

      // Update button state
      this.form_helper.setCompleted();
      setTimeout(() => {
        this.onImageRemove();
      }, BUTTON_TRANSITION_DURATION);
    } catch (e) {
      this.form_helper.setReady();
      this.error_modal.showError(e);
    }
  }

  async setImageAsProfile(image) {
    // Get S3 bucket to upload
    const data = await this.apiService.getImageUploadURL(image);
    // Upload image to S3 bucket
    await fetch(data.url.url, { method: "PUT", body: image });
    // // Set uploaded image as profile image
    await this.apiService.setImageAsProfile(data.url.resourceUrl);
  }
}

class DashboardPersonalize {
  static selectors = {
    about_you_modal: "[data-aboutyou-modal]",
    delete_modal: "[data-delete-modal]",
    edit_modal: "[data-edit-modal]",
    add_product_modal: "[data-add-modal]",
    reorder_modal: "[data-reorder-modal]",
  };

  constructor() {
    this.wrapper = document;

    // Bail if personalize modals do not exist on this page
    const personalizeRoot = this.wrapper.querySelector(
      `${DashboardPersonalize.selectors.about_you_modal}, ${DashboardPersonalize.selectors.add_product_modal}, ${DashboardPersonalize.selectors.reorder_modal}, ${DashboardPersonalize.selectors.delete_modal}, ${DashboardPersonalize.selectors.edit_modal}`
    );
    if (!personalizeRoot) return;

    this.about_you_modal = this.wrapper.querySelector(
      DashboardPersonalize.selectors.about_you_modal
    );
    this.add_product_modal = this.wrapper.querySelector(
      DashboardPersonalize.selectors.add_product_modal
    );
    this.reorder_modal = this.wrapper.querySelector(
      DashboardPersonalize.selectors.reorder_modal
    );
    this.init();
    modal("personalize");
  }

  init() {
    if (this.about_you_modal) {
      new DashboardPersonalizeAboutYou(this.wrapper, this.about_you_modal);
    }
    new DashboardPersonalizePrefs();
    if (this.add_product_modal) {
      new DashboardPersonalizeFeaturedProducts(this.wrapper, this.add_product_modal);
    }
    if (this.reorder_modal) {
      new DashboardPersonalizeReorder(this.wrapper, this.reorder_modal);
    }
  }
}

class DashboardPersonalizeAboutYou {
  static selectors = {
    about_you_modal: "[data-aboutyou-modal]",
    about_you: "#personalize-aboutyou-input",
    about_you_submit: "[data-aboutyou-submit]",
    about_you_preview: "[data-aboutyou-preview]",
  };

  constructor() {
    this.wrapper = document;
    // Edit email form elems
    this.about_you_input = this.wrapper.querySelector(
      DashboardPersonalizeAboutYou.selectors.about_you
    );
    this.about_you_submit = this.wrapper.querySelector(
      DashboardPersonalizeAboutYou.selectors.about_you_submit
    );

    // Edit email data elems
    this.about_you_preview = this.wrapper.querySelector(
      DashboardPersonalizeAboutYou.selectors.about_you_preview
    );
    this.initialAboutYou = this.about_you_input.value;
    this.aboutYou = this.initialAboutYou;

    this.form_helper = new DashboardFormHelper({
      btnElem: this.about_you_submit,
      inputElems: [this.about_you_input],
      modalName: "about-you",
    });
    this.error_modal = new DashboardErrorModal();
    this.apiService = new ApiService();
    this.init();
  }

  init() {
    this.about_you_input.addEventListener(
      "input",
      this.onAboutYouChange.bind(this)
    );
    this.about_you_submit.addEventListener(
      "click",
      this.onAboutYouSubmit.bind(this)
    );
  }

  onAboutYouChange() {
    this.aboutYou = this.about_you_input.value;
    const isValid = this.about_you_input.checkValidity();
    this.form_helper.toggleButton(isValid);
  }

  async onAboutYouSubmit() {
    try {
      this.form_helper.setLoading();
      await this.apiService.setMetafield({ aboutYou: this.aboutYou });
      DashboardFormHelper.updateDOM({
        data: this.aboutYou,
        elem: this.about_you_preview,
      });
      this.form_helper.setCompleted();
    } catch (e) {
      this.form_helper.setReady();
      this.error_modal.showError(e);
    }
  }
}

class DashboardPersonalizePrefs {
  static selectors = {
    email_checkbox: "[data-email-pref]",
    phone_checkbox: "[data-phone-pref]",
    contact_method_input: "data-contact-method-pref",
  };

  constructor() {
    this.wrapper = document;
    this.email_checkbox = this.wrapper.querySelector(
      DashboardPersonalizePrefs.selectors.email_checkbox
    );
    this.phone_checkbox = this.wrapper.querySelector(
      DashboardPersonalizePrefs.selectors.phone_checkbox
    );
    this.contact_method_inputs = this.wrapper.querySelectorAll(
      `[${DashboardPersonalizePrefs.selectors.contact_method_input}]`
    );

    // Bail if prefs UI is not present on this page
    if (!this.email_checkbox || !this.phone_checkbox) return;

    this.error_modal = new DashboardErrorModal();
    this.apiService = new ApiService();
    this.init();
  }

  init() {
    this.email_checkbox.addEventListener(
      "change",
      this.onPrefsChange.bind(this)
    );
    this.phone_checkbox.addEventListener(
      "change",
      this.onPrefsChange.bind(this)
    );
    this.contact_method_inputs.forEach((input) => {
      input.addEventListener("change", (event) => {
        const selectedInput = this.wrapper.querySelector(
          `[${DashboardPersonalizePrefs.selectors.contact_method_input}]:checked`
        );
        const selected = selectedInput.getAttribute(
          DashboardPersonalizePrefs.selectors.contact_method_input
        );
        this.apiService.setMetafield({ contactMethodPref: selected });
      });
    });
  }

  onPrefsChange() {
    this.apiService.setMetafield({
      hideEmail: this.email_checkbox.checked,
      hidePhone: this.phone_checkbox.checked,
    });
  }
}

class DashboardPersonalizeFeaturedProducts {
  static selectors = {
    search_page: "[data-search-page]",
    edit_page: "[data-edit-page]",
    show_feedback: "[data-show-feedback-page]",
    back_btn: "[data-go-back-modal]",
    search_result: "[data-search-result]",
    search_input: "[data-search-input]",
    feedback_textarea: "[data-featured-edit]",
    feedback_submit: "[data-feedback-submit]",
    text_length: "[data-text-length]",
    product_radio: "input[name='personalize_search_product']",
    error_message: "#personalize-featured-error-message",
    search_loading: "[data-search-loading]",
    search_footer: "[data-search-footer]",
    search_result_empty: "[data-search-result-empty]",
    edit_featured_product: ".edit-featured-product",
    edit_featured_product_textarea: "[data-featured-update]",
    edit_featured_product_submit: "[data-featured-update-submit]",
    delete_featured_product: ".delete-featured-product",
    delete_featured_product_submit: "[data-featured-delete-submit]",
  };
  static MAX_FEEDBACK = 140;

  constructor(wrapper, modal) {
    this.wrapper = wrapper;
    this.modal = modal;

    this.search_page = this.modal.querySelector(
      DashboardPersonalizeFeaturedProducts.selectors.search_page
    );
    this.edit_page = this.modal.querySelector(
      DashboardPersonalizeFeaturedProducts.selectors.edit_page
    );
    this.search_result = this.modal.querySelector(
      DashboardPersonalizeFeaturedProducts.selectors.search_result
    );
    this.search_input = this.modal.querySelector(
      DashboardPersonalizeFeaturedProducts.selectors.search_input
    );
    this.show_feedback = this.modal.querySelector(
      DashboardPersonalizeFeaturedProducts.selectors.show_feedback
    );
    this.feedback_textarea = this.modal.querySelector(
      DashboardPersonalizeFeaturedProducts.selectors.feedback_textarea
    );
    this.feedback_submit = this.modal.querySelector(
      DashboardPersonalizeFeaturedProducts.selectors.feedback_submit
    );
    this.back_btn = this.modal.querySelector(
      DashboardPersonalizeFeaturedProducts.selectors.back_btn
    );
    this.text_length = this.modal.querySelector(
      DashboardPersonalizeFeaturedProducts.selectors.text_length
    );
    this.error_message = this.modal.querySelector(
      DashboardPersonalizeFeaturedProducts.selectors.error_message
    );
    this.search_loading = this.modal.querySelector(
      DashboardPersonalizeFeaturedProducts.selectors.search_loading
    );
    this.search_footer = this.modal.querySelector(
      DashboardPersonalizeFeaturedProducts.selectors.search_footer
    );
    this.search_result_empty = this.modal.querySelector(
      DashboardPersonalizeFeaturedProducts.selectors.search_result_empty
    );
    this.edit_featured_products = this.wrapper.querySelectorAll(
      DashboardPersonalizeFeaturedProducts.selectors.edit_featured_product
    );
    this.edit_featured_product_textarea = this.wrapper.querySelector(
      DashboardPersonalizeFeaturedProducts.selectors
        .edit_featured_product_textarea
    );
    this.edit_featured_product_submit = this.wrapper.querySelector(
      DashboardPersonalizeFeaturedProducts.selectors
        .edit_featured_product_submit
    );
    this.delete_featured_product = this.wrapper.querySelectorAll(
      DashboardPersonalizeFeaturedProducts.selectors.delete_featured_product
    );
    this.delete_featured_product_submit = this.wrapper.querySelector(
      DashboardPersonalizeFeaturedProducts.selectors
        .delete_featured_product_submit
    );

    this.form_helper = new DashboardFormHelper({
      btnElem: this.feedback_submit,
      inputElems: [this.feedback_textarea],
    });

    this.apiService = new ApiService();
    this.error_modal = new DashboardErrorModal();
    this.init();
  }

  init() {
    this.search_input.addEventListener(
      "input",
      DashboardFormHelper.debounce(
        (event) => this.onSearchChange(event),
        300
      ).bind(this)
    );

    this.show_feedback.addEventListener("click", this.showEditPage.bind(this));

    this.back_btn.addEventListener("click", this.showSearchPage.bind(this));

    this.feedback_textarea.addEventListener(
      "input",
      this.onFeedbackChange.bind(this)
    );
    this.edit_featured_product_textarea.addEventListener(
      "input",
      this.onFeedbackUpdateChange.bind(this)
    );
    this.onFeedbackChange();

    this.feedback_submit.addEventListener(
      "click",
      this.onFeedbackSubmit.bind(this)
    );
    this.edit_featured_product_submit.addEventListener(
      "click",
      this.onFeedbackUpdateSubmit.bind(this)
    );
    this.edit_featured_products.forEach((product) => {
      product.addEventListener("click", this.onEditFeaturedProduct.bind(this));
    });

    this.delete_featured_product.forEach((product) => {
      product.addEventListener(
        "click",
        this.onDeleteFeaturedProduct.bind(this)
      );
    });
    this.delete_featured_product_submit.addEventListener(
      "click",
      this.onDeleteFeaturedProductSubmit.bind(this)
    );
  }

  onEditFeaturedProduct(event) {
    const productIndex = event.target.getAttribute("data-product-index");
    const feedback = event.target.getAttribute(
      "data-featured-product-feedback"
    );
    this.product_index = productIndex;
    this.feedback = feedback;

    this.renderEditModal(feedback);
  }

  renderEditModal(feedback) {
    this.edit_featured_product_textarea.value = feedback;
  }

  async onFeedbackUpdateSubmit() {
    try {
      this.edit_featured_product_submit.disabled = true;
      this.edit_featured_product_submit.innerHTML = "Updating...";
      await this.apiService.updateFeaturedProduct(
        "product_" + this.product_index,
        this.feedback
      );
      // // Update order in DOM
      location.reload();
    } catch (e) {
      this.edit_featured_product_submit.disabled = false;
      this.edit_featured_product_submit.innerHTML = "Update";
      this.error_modal.showError(e);
      console.error(e);
    }
  }

  onDeleteFeaturedProduct(event) {
    const productIndex = event.target.getAttribute("data-product-index");
    this.product_index = productIndex;
  }

  async onDeleteFeaturedProductSubmit() {
    try {
      this.delete_featured_product_submit.disabled = true;
      this.delete_featured_product_submit.innerHTML = "Deleting...";
      await this.apiService.deleteFeaturedProduct(
        "product_" + this.product_index
      );
      // // Update order in DOM
      location.reload();
    } catch (e) {
      this.delete_featured_product_submit.disabled = false;
      this.delete_featured_product_submit.innerHTML = "Delete";
      this.error_modal.showError(e);
      console.error(e);
    }
  }

  onSearchChange() {
    this.product_id = null;
    this.updateFooter();

    const searchTerm = this.search_input.value.trim();
    if (!searchTerm.length) {
      this.reset();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  async getSearchResults(searchTerm) {
    try {
      this.setLoading();
      const searchResult = await this.apiService.getProductSearch(searchTerm);
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = searchResult;
      const searchSection = tempDiv.querySelector(
        "#shopify-section-dashboard-predictive-search"
      );
      if (searchSection) {
        const items = searchSection.querySelectorAll("li[data-search-item]");
        items.forEach((item) => {
          const label = item.querySelector('label[style="display:none"]');
          if (
            label &&
            (label.textContent.includes("Bundle") ||
              label.textContent.includes("Weekly_Offers") ||
              label.textContent.includes("Non Commissionable") ||
              label.textContent.includes("Not Discount Eligible") ||
              label.textContent.includes("Hide From Search"))
          ) {
            item.remove();
          }
        });
      }

      this.search_result.innerHTML = searchSection.innerHTML;
      this.attachEventListeners();
      this.search_result_empty.classList.add("hidden");
      this.hideLoading();
    } catch (e) {
      console.error(e);
      this.error_modal.showError(e);
    }
  }

  attachEventListeners() {
    this.product_inputs = this.search_result.querySelectorAll(
      DashboardPersonalizeFeaturedProducts.selectors.product_radio
    );
    this.product_inputs.forEach((input) => {
      input.addEventListener("change", (event) => this.onProductChange(event));
    });
  }

  reset() {
    // Reset state
    this.product_id = null;
    this.search_result_empty.classList.remove("hidden");
    // Reset DOM
    this.search_result.innerHTML = "";
    this.search_input.value = "";
    this.feedback_textarea.value = "";
    this.showSearchPage();
    this.hideLoading();
    this.updateFooter();
  }

  async onFeedbackUpdateChange() {
    this.feedback = this.edit_featured_product_textarea.value;
    const isValid = this.edit_featured_product_textarea.checkValidity();
    this.form_helper.toggleButton(isValid);
  }

  async onFeedbackChange() {
    this.feedback = this.feedback_textarea.value;
    const isValid = this.feedback_textarea.checkValidity();
    this.form_helper.toggleButton(isValid);
    this.text_length.innerHTML = `(${this.feedback.length}/${DashboardPersonalizeFeaturedProducts.MAX_FEEDBACK})`;
  }

  async onFeedbackSubmit() {
    try {
      this.form_helper.setLoading();
      // Update featured product
      await this.apiService.addFeaturedProduct(this.product_id, this.feedback);
      this.form_helper.setCompleted();
      // // Update order in DOM
      location.reload();
    } catch (e) {
      this.form_helper.setReady();
      this.error_modal.showError(e);
      console.error(e);
    }
  }

  onProductChange(event) {
    this.product_id = event.target.value;
    this.updateFooter();
  }

  setLoading() {
    this.search_loading.classList.remove("hidden");
  }

  hideLoading() {
    this.search_loading.classList.add("hidden");
  }

  showEditPage() {
    this.search_page.classList.add("hidden");
    this.edit_page.classList.remove("hidden");
    this.feedback_textarea.focus();
  }

  updateFooter() {
    if (this.product_id) this.search_footer.classList.remove("hidden");
    else this.search_footer.classList.add("hidden");
  }

  showSearchPage() {
    this.search_page.classList.remove("hidden");
    this.edit_page.classList.add("hidden");
  }
}

class DashboardPersonalizeReorder {
  static selectors = {
    modal: "[data-reorder-modal]",
    //   close_box_btn: "[data-close-box]",
    box: "[data-modal-box]",
    save_reorder_btn: "[data-reorder-submit]",
    reorder_list: "[data-reorder-list]",
    featured_product_list: "[data-featured-product-list]",
    reorder_item: "[data-reorder-item]",
  };

  constructor(wrapper, modal) {
    this.wrapper = wrapper;
    this.modal = modal;
    this.close_box_btn = this.modal.querySelector(
      DashboardPersonalizeReorder.selectors.close_box_btn
    );
    this.box = this.modal.querySelector(
      DashboardPersonalizeReorder.selectors.box
    );
    this.save_reorder_btn = this.modal.querySelector(
      DashboardPersonalizeReorder.selectors.save_reorder_btn
    );
    this.reorder_list = this.modal.querySelector(
      DashboardPersonalizeReorder.selectors.reorder_list
    );
    this.featured_product_list = this.wrapper.querySelector(
      DashboardPersonalizeReorder.selectors.featured_product_list
    );
    this.reorder_items = this.wrapper.querySelectorAll(
      DashboardPersonalizeReorder.selectors.reorder_item
    );

    this.sortable = new Sortable(this.reorder_list, { animation: 150 });
    this.product_order = this.sortable.toArray();

    this.apiService = new ApiService();
    this.error_modal = new DashboardErrorModal();
    this.form_helper = new DashboardFormHelper({
      btnElem: this.save_reorder_btn,
    });

    this.init();
  }

  init() {
    modal("personalize-reorder", this.onOpenModal.bind(this));
    //   this.close_box_btn.addEventListener("click", this.onCloseBox.bind(this));
    this.save_reorder_btn.addEventListener(
      "click",
      this.onSaveReorder.bind(this)
    );
  }

  onCloseBox() {
    this.box.classList.add("d-none");
  }

  async onSaveReorder() {
    try {
      this.form_helper.setLoading();

      // Save order state
      this.product_order = this.sortable.toArray();

      // Update order in Shopify
      await this.apiService.reorderFeaturedProduct(this.product_order);

      // // // Update button state
      this.form_helper.setCompleted();

      // // // Update order in DOM
      location.reload();
    } catch (e) {
      console.error(e);
      this.error_modal.showError(e);
    }
  }

  onOpenModal() {
    this.form_helper.setReady();
    this.sortable.sort(this.product_order);
  }
}

class ApiService {
  constructor() {
    this.accessToken = window.customer?.accessToken || "";
    this.apiUrl = "https://ff-prd.api.sultans.co";
    // this.apiUrl = 'http://localhost:8080';
    this.headers = {
      Authorization: `Bearer ${this.accessToken}`,
      Accept: "application/json",
    };
  }

  async getPartner(partnerSite) {
    const url = `${this.apiUrl}/partners/search?site=${partnerSite}`;
    const response = await fetch(url).then((response) => {
      if (response.status !== 200) {
        return false;
      }
      return response.json();
    });
    return response;
  }

  async setName(first_name, last_name) {
    const url = `${this.apiUrl}/partners/name`;
    return await fetch(url, {
      method: "PUT",
      body: JSON.stringify({ first_name, last_name }),
      headers: this.headers,
    }).then(async (res) => {
      if (!res.ok)
        return res.text().then((text) => {
          throw new Error(text);
        });

      return res.json();
    });
  }

  async setEmail(email) {
    const url = `${this.apiUrl}/partners/email`;
    return await fetch(url, {
      method: "PUT",
      body: JSON.stringify({ email }),
      headers: this.headers,
    }).then(async (res) => {
      return res.json();
    });
  }

  async setPhone(phone) {
    const url = `${this.apiUrl}/partners/phone`;
    return await fetch(url, {
      method: "PUT",
      body: JSON.stringify({ phone }),
      headers: this.headers,
    }).then(async (res) => {
      if (!res.ok)
        return res.text().then((text) => {
          throw new Error(text);
        });

      return res.json();
    });
  }

  async setPassword(password, confirm_password) {
    const url = `${this.apiUrl}/partners/password`;
    return await fetch(url, {
      method: "PUT",
      body: JSON.stringify({ password, confirm_password }),
      headers: this.headers,
    }).then(async (res) => {
      if (!res.ok)
        return res.text().then((text) => {
          throw new Error(text);
        });

      return res.json();
    });
  }

  async getImageUploadURL(file) {
    const url = `${this.apiUrl}/partners/image-upload-url?size=${file.size}&type=${file.type}`;

    return await fetch(url, {
      method: "GET",
      headers: this.headers,
    }).then(async (res) => {
      if (!res.ok)
        return res.text().then((text) => {
          throw new Error(text);
        });
      return res.json();
    });
  }

  async setImageAsProfile(image_url) {
    const url = `${this.apiUrl}/partners/set-profile-image`;
    return await fetch(url, {
      method: "PUT",
      body: JSON.stringify({ image_url }),
      headers: this.headers,
    }).then(async (res) => {
      if (!res.ok)
        return res.text().then((text) => {
          throw new Error(text);
        });

      return res.json();
    });
  }

  async setMetafield(payload) {
    const url = `${this.apiUrl}/partners/metafield`;
    return await fetch(url, {
      method: "PUT",
      body: JSON.stringify(payload),
      headers: this.headers,
    }).then(async (res) => {
      if (!res.ok)
        return res.text().then((text) => {
          throw new Error(text);
        });

      return res.json();
    });
  }

  async getProductSearch(searchTerm) {
    return await fetch(
      `/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=10&section_id=dashboard-predictive-search`
    ).then((res) => {
      if (!res.ok) {
        return res.text().then((text) => {
          throw new Error(text);
        });
      }
      console.log("res:", res);
      return res.text();
    });
  }

  async addFeaturedProduct(productID, feedback) {
    const url = `${this.apiUrl}/partners/featured-product`;
    await fetch(url, {
      method: "POST",
      body: JSON.stringify({ productID, feedback }),
      headers: this.headers,
    }).then(async (res) => {
      if (!res.ok)
        return res.text().then((text) => {
          throw new Error(text);
        });
    });
  }

  async reorderFeaturedProduct(newOrder) {
    const url = `${this.apiUrl}/partners/featured-products-reorder`;
    await fetch(url, {
      method: "PUT",
      body: JSON.stringify({ newOrder }),
      headers: this.headers,
    }).then(async (res) => {
      if (!res.ok)
        return res.text().then((text) => {
          throw new Error(text);
        });
    });
  }

  async updateFeaturedProduct(metafieldKey, feedback) {
    const url = `${this.apiUrl}/partners/featured-product`;
    await fetch(url, {
      method: "PUT",
      body: JSON.stringify({ metafieldKey, feedback }),
      headers: this.headers,
    }).then(async (res) => {
      if (!res.ok)
        return res.text().then((text) => {
          throw new Error(text);
        });
    });
  }

  async deleteFeaturedProduct(metafieldKey) {
    const url = `${this.apiUrl}/partners/featured-product`;
    await fetch(url, {
      method: "DELETE",
      body: JSON.stringify({ metafieldKey }),
      headers: this.headers,
    }).then(async (res) => {
      if (!res.ok)
        return res.text().then((text) => {
          throw new Error(text);
        });
    });
  }
}

function validateTextInput(text, allowUrl = false) {
  if (allowUrl) return /^[a-zA-Z0-9À-ÿ\s-._~:/?#[\]@!$&'()*+,;=%]+$/.test(text);
  return /^[a-zA-Z0-9À-ÿ\s-]+$/.test(text);
}

function modal(unique) {
  const uniqueID = `data-popup-${unique}`;
  window.MicroModal.init({
    openTrigger: uniqueID,
    disableScroll: true,
    onShow: (modal, el, event) => {
      event.preventDefault();
      // const firstFocus = modal.querySelector(selectors$P.focusable);
      // trapFocus(modal, { elementToFocus: "button" });
    },
    onClose: (modal, el, event) => {
      event && event.preventDefault();
      // removeTrapFocus();
      el && el.focus();
    },
  });
}

function registerModules() {
  new PartnerSelect();
  new PartnerInfoModal();
  new CustomerDashboard();

  new DashboardPersonalize();
}

registerModules();
